import { createFileRoute } from '@tanstack/react-router';
import { Heading } from 'react-aria-components';
import Markdown from 'react-markdown';
import RootLayout from 'src/components/layout/RootLayout';
import { termsMD } from 'src/components/TermsModal';
import useSkeletonCleanup from 'src/init/useSkeletonCleanup';

const TermsPage = () => {
  useSkeletonCleanup();

  return (
    <RootLayout className="h-full flex flex-col">
      <div className="w-full max-w-[47.5rem] mx-auto bg-surface-alt rounded-3xl shadow-3 p-11 flex-1 min-h-0 overflow-auto">
        <Heading
          level={1}
          className="text-surface-alt-90 text-2xl font-bold mb-6"
        >
          Terms of Services
        </Heading>
        <Markdown className="markdown">{termsMD}</Markdown>
      </div>
    </RootLayout>
  );
};

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});
